const BORROW_APY = 5.5;

export default BORROW_APY;
